import { Pagination } from "@mui/material";
import { type RaRecord } from "react-admin";

import { useTypedListContext } from "@/hooks";

type ListPaginationByLimitProps = { perPage?: number };

type LimitFilter = { limit?: number };

export const ListPaginationByLimit = (props: ListPaginationByLimitProps) => {
  const { page, filterValues, setPage, total, perPage } = useTypedListContext<
    RaRecord,
    LimitFilter
  >();

  const itemsPerPage = filterValues.limit ?? props.perPage ?? perPage;

  return (
    <Pagination
      sx={{ minHeight: "56px", display: "flex", alignItems: "center" }}
      count={total && itemsPerPage > 0 ? Math.ceil(total / itemsPerPage) : 1}
      page={page}
      onChange={(_, newPage) => setPage(newPage)}
    />
  );
};
